import { MouseEvent, useMemo } from "react";
import { getRangeWithDots } from "./getRangeWithDots";
import { ResourcedTexts } from "../SearchFilterResultData";
import clsx from "clsx";

type PaginationProps = {
  resourcedTexts: ResourcedTexts;
  pageNr: number;
  itemsPerPage: number;
  totalResults: number;
  onPageClick: (newPageNr: number) => void;
  loading?: boolean;
};

export function Pagination({
  pageNr,
  itemsPerPage,
  totalResults,
  onPageClick,
  loading,
}: PaginationProps) {
  const nrOfPages = useMemo(
    () => Math.ceil(totalResults / itemsPerPage),
    [totalResults, itemsPerPage]
  );

  const prevPageNr = pageNr - 1;
  const nextPageNr = pageNr + 1;
  const isFirstPage = pageNr <= 1;
  const isLastPage = pageNr >= nrOfPages;

  function handlePageClick(e: MouseEvent, pageNr: number) {
    e.preventDefault();

    if (loading) {
      return;
    }

    onPageClick(pageNr);
  }

  function renderPageNumbers() {
    const rangeWithDots = getRangeWithDots(pageNr, nrOfPages);

    return rangeWithDots.map((item, index) => {
      const isActive = pageNr === item;

      if (item === "...") {
        return (
          <div className="pagination__ellipsis" key={item + index}>
            {item}
          </div>
        );
      } else {
        const numberItem = item as number;
        return (
          <a
            key={numberItem.toString() + index}
            href="#"
            className={clsx("pagination__number", isActive && "active")}
            onClick={(e) => handlePageClick(e, numberItem)}
          >
            {numberItem}
          </a>
        );
      }
    });
  }

  return (
    <div className="pagination">
      {isFirstPage ? (
        <span className="pagination__prev inactive">&nbsp;</span>
      ) : (
        <a className="pagination__prev" href="#" onClick={(e) => handlePageClick(e, prevPageNr)} />
      )}

      <div className="numbers">{renderPageNumbers()}</div>

      {isLastPage ? (
        <span className="pagination__next inactive">&nbsp;</span>
      ) : (
        <a className="pagination__next" href="#" onClick={(e) => handlePageClick(e, nextPageNr)} />
      )}
    </div>
  );
}
